var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4287_1061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 1.33333C5.41992 1.33333 3.33325 3.42 3.33325 6C3.33325 9.5 7.99992 14.6667 7.99992 14.6667C7.99992 14.6667 12.6666 9.5 12.6666 6C12.6666 3.42 10.5799 1.33333 7.99992 1.33333ZM7.99992 7.66667C7.07992 7.66667 6.33325 6.92 6.33325 6C6.33325 5.08 7.07992 4.33333 7.99992 4.33333C8.91992 4.33333 9.66659 5.08 9.66659 6C9.66659 6.92 8.91992 7.66667 7.99992 7.66667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4287_1061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZones);
export default __webpack_public_path__ + "static/media/zones.93cf18633178f69c68cd094beee1865e.svg";
export { ForwardRef as ReactComponent };